import Region from "@/models/server/Region";

export default class ProductRegion {
    public regionId: string = "";
    
    public productId: string = "";
    
    public externalId: string = "";
    
    public region: Region | null = null
}